type Format = 'long' | 'short' | 'trimmed' | 'medium'

export const formatDate = (date: string, format: Format): string => {
  let option: Intl.DateTimeFormatOptions = {}

  switch (format) {
    case 'medium':
      option = { month: 'long', day: '2-digit', year: 'numeric' }

      break

    case 'trimmed':
      option = { month: 'short', day: 'numeric', year: 'numeric' }

      break

    case 'short':
      return date.split('T')[0]

    case 'long':
      option = {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }

      break
  }

  return new Date(`${date}Z`).toLocaleString('en-US', option)
}
